import { Path, Svg } from '../../svg';

/**
 * Google "G" brand mark, drawn once with the shared SVG primitives. Brand
 * fills are fixed by Google's guidelines, so `color` is accepted for the
 * `IconComponent` shape and deliberately ignored — the same mark in light and
 * dark mode. Paths are the ones flashka-web and flashka-app each carried.
 */
export function GoogleIcon({
  size = 20,
  className,
}: {
  color?: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <Path
        fill="#4285F4"
        d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.58-5.17 3.58-8.81Z"
      />
      <Path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.88-3c-1.07.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.72-4.95H1.27v3.1A12 12 0 0 0 12 24Z"
      />
      <Path
        fill="#FBBC05"
        d="M5.28 14.29a7.21 7.21 0 0 1 0-4.58v-3.1H1.27a12 12 0 0 0 0 10.78l4.01-3.1Z"
      />
      <Path
        fill="#EA4335"
        d="M12 4.77c1.76 0 3.34.61 4.59 1.8l3.44-3.44A11.99 11.99 0 0 0 1.27 6.61l4.01 3.1C6.22 6.88 8.87 4.77 12 4.77Z"
      />
    </Svg>
  );
}
